import { Component, AfterViewInit, Input, OnInit } from '@angular/core';

import { ShipmentService } from '../shipment.service';
import { FormArray } from '@angular/forms';

@Component({
   selector: 'shipment-summary',
   templateUrl: './summary.component.html',
   styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements AfterViewInit, OnInit {

   @Input()
   quotationId?: string;

   @Input()
   cost?: string;

   s: ShipmentService;
   calcDisabled = false;

   constructor( private shipmentService: ShipmentService ) { }

   ngOnInit(): void {
      this.shipmentService.shipmentUpdate$.subscribe(( s ) => {
         if ( s ) {
            this.s = this.shipmentService;

            this.calcDisabled = (this.shipmentService.shipmentForm.get('calculator') as FormArray).controls[0]?.get('__patch').disabled;
         }
      });
   }

   ngAfterViewInit() {
      setTimeout( _ => this.s.focused.next( 'type' ), 1 );
   }

   scrollToTop() {
      window.scroll({ top: 0, behavior: 'smooth' });
   }
}
